import styles from "./Loader.module.scss";
import { Preloader } from "../../../../components";

export const Loader = () => (
  <div className={styles.loaderWrapper}>
    <Preloader type="bar" />
  </div>
);
